import React from 'react';
import { Segment } from './types';
import StoreAddress from './StoreAddress';
import LineItem from './LineItem';
import ProgressBar from '../ProgressBar';
import { prependLocaleToUrl } from '../../../../utils/localization';

const ShipmentCard = ({
  segment,
  totalSegments,
  orderReference,
  token,
  orderShippingCountryCode,
}: {
  segment: Segment;
  totalSegments: number;
  orderReference: string;
  token: string | null;
  orderShippingCountryCode: string;
}) => {
  const returnCopy = segment?.return_portal_url?.toLowerCase().includes('global')
    ? 'Start A Return'
    : 'Return Or Exchange';
  const trackingUrl = prependLocaleToUrl(segment.shipment?.tracking_url || '');
  const returnPortalUrl = segment.return_portal_url;
  const hasTrackingLink = Boolean(segment.shipment?.tracking_number && trackingUrl);
  const hasReturnLink = Boolean(segment.return_eligible && returnPortalUrl);

  return (
    <div className="shipment">
      <div className="shipment-header">
        <div className="tracking-status">
          <p className="body-large">
            Shipment {segment.sequence}/{totalSegments}
          </p>
          <p className="editorial-large">{segment.display_status}</p>
          <p className="body-small">{segment.status_message}</p>
          {(segment.type === 'pickup' || segment.type === 'in_store') && segment.store_location ? (
            <div className="">
              <StoreAddress location={segment.store_location} />
            </div>
          ) : null}
          {segment.progress ? <ProgressBar percentage={segment.progress} /> : null}
        </div>
        {(hasTrackingLink || hasReturnLink) && (
          <div className="tracking-return">
            {hasTrackingLink && (
              <a href={trackingUrl} className="button button-primary-md">
                Track Shipment
              </a>
            )}
            {hasReturnLink && returnPortalUrl && (
              <a href={returnPortalUrl} className="button button-ghost-md">
                {returnCopy}
              </a>
            )}
          </div>
        )}
      </div>
      <div className="shipment-line-items">
        {segment.items.map((item) => (
          <LineItem
            item={item}
            returnExchangeCopy={item.return_status}
            orderShippingCountryCode={orderShippingCountryCode}
          />
        ))}
      </div>
    </div>
  );
};

export default ShipmentCard;
